import React, { useContext } from "react";

// Import Contexts
import { ClinicContext, LanguageContext, ScreenContext } from "contexts";

// Import Components
import {
  TitleBar,
  BodyScanInstructions,
  PrimaryButton,
} from "components/index";
import { Language, ProcedureType, TScreen, TScreenContext } from "api/type";
import { getTranslation } from "utils/translate";
import { mixpanelTrack } from "utils/mixpanel";

type ScreenScanInstructionsProps = {
  selectedProcedure: ProcedureType | null;
};

const ScreenScanInstructions: React.FC<ScreenScanInstructionsProps> = ({
  selectedProcedure,
}) => {
  // Context
  const language = useContext<Language>(LanguageContext)[0];
  const clinic = useContext(ClinicContext);
  const setScreen = useContext<TScreenContext>(ScreenContext)[1];

  React.useEffect(() => {
    if (!clinic || !selectedProcedure) return;
    if (document.referrer.includes("staging")) return;
    mixpanelTrack("Form Started", [
      {
        propertyName: "Clinic Name",
        propertyValue: clinic.clinic_name,
      },
      {
        propertyName: "Procedure",
        propertyValue: selectedProcedure,
      },
    ]);
  }, [clinic, selectedProcedure]);

  return (
    <div className="screen-container">
      <TitleBar
        name={getTranslation("scanInstructions", language)}
        onClickBackButton={() => setScreen(TScreen.VIDEO_SCREEN)}
        centerTitle
        showLogo={false}
      />
      <BodyScanInstructions />
      <PrimaryButton
        onClick={() => {
          setScreen(TScreen.BODY_SCAN_SCREEN);
        }}
        fullWidth
        text={getTranslation("continue", language)}
      />
    </div>
  );
};

export default ScreenScanInstructions;
